import { z } from 'zod';
import {
    BusinessDocTypeFieldMappingViewModel,
    BusinessDocTypeFieldMappingFormSchema,
} from './BusinessDocTypeFieldMappingViewModel';

/**
 * Zod schema for BusinessDocTypeMapping form validation
 */
export const BusinessDocTypeMappingFormSchema = z.object({
    Id: z.number().int(),
    SourceBusinessDocTypeId: z.number().int().min(1, 'Source Document Type is required'),
    SourceBusinessDocSubTypeId: z.number().int(),
    TargetBusinessDocTypeId: z.number().int().min(1, 'Target Document Type is required'),
    TargetBusinessDocSubTypeId: z.number().int(),
    XSLT: z.string().nullable(),
    Active: z.boolean(),
    CreatedTime: z.union([z.string(), z.date()]).optional(),
    LastUpdateDate: z.union([z.string(), z.date()]).optional(),
    RowVersion: z.string().optional(),
    /** Collection of field mappings for this document type mapping */
    BusinessDocTypeFieldMappings: z.array(BusinessDocTypeFieldMappingFormSchema),
});

/**
 * Form data type for mappings (used in UI forms)
 */
export type BusinessDocTypeMappingFormData = z.infer<typeof BusinessDocTypeMappingFormSchema>;

/**
 * GetBusinessDocTypeMappingViewModel
 * Full API response type including server-generated fields
 */
export interface GetBusinessDocTypeMappingViewModel {
    Id: number;
    SourceBusinessDocTypeId: number;
    SourceBusinessDocSubTypeId: number;
    TargetBusinessDocTypeId: number;
    TargetBusinessDocSubTypeId: number;
    XSLT: string | null;
    Active: boolean;
    /** Server-managed */
    CreatedTime?: string | Date;
    /** Server-managed */
    LastUpdateDate?: string | Date;
    RowVersion?: string;
    /** Collection of field mappings for this document type mapping */
    BusinessDocTypeFieldMappings?: BusinessDocTypeFieldMappingViewModel[];
    CompanyId: number | null;
}

/**
 * CreateUpdateDeleteBusinessDocTypeMappingViewModel
 * Response type for create, update, and delete operations
 */
export interface CreateUpdateDeleteBusinessDocTypeMappingViewModel {
    ID: number;
}
